import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { setResellerParams } from 'api';
import { MyThunkDispatch, RootState } from 'store';

import { getAccount } from 'actions/user';
import useToast from 'hooks/useToast';
import { BranchCompany } from 'models/branchCompany';
import { PaymentCardData } from 'models/paymentCard';
import UserCountrySelectionComponent from 'screens/components/UserCountrySelection';
import { getAllBranchesCompany } from 'services/branchCompanyService';

interface Params {
  cardSelected: PaymentCardData;
  showCardSelection?: boolean;
}

const UserCountrySelectionContainer = ({ cardSelected, showCardSelection }: Params) => {
  const [countryList, setCountryList] = useState<BranchCompany[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const accountResult = useSelector((state: RootState) => state.user.accountResult);
  const dispatch: MyThunkDispatch = useDispatch();
  const history = useHistory();

  const getCardList = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getAllBranchesCompany(accountResult !== null ? accountResult.companyId : '');
      setIsLoading(false);
      setCountryList(response);
    } catch (error) {
      toast.add({
        type: 'danger',
        message: error.message,
      });
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toast]);

  useEffect(() => {
    getCardList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClick = async (branchCompany: BranchCompany) => {
    //Si es la misma empresa logueada, no hace nada
    if (accountResult?.companyId === branchCompany.id) {
      history.goBack();
    }

    setIsLoading(true);

    setResellerParams(branchCompany.countryId, branchCompany.id);

    const user = await dispatch<any>(getAccount(branchCompany.id));

    setResellerParams(user.countryId, branchCompany.id);

    if (user) {
      if (user?.type === 'admin' && !user?.onboardingDone) {
        history.replace(`/corporate/onboarding?email=${user.email}&name=${user.name}&lastName=${user.lastName}`);
      } else if (user?.type?.toLowerCase() === 'guest') {
        history.replace('/corporate/login-not-authorized');
      } else if (user?.isGroupApprover) {
        history.replace('/corporate/dashboard');
      } else {
        history.replace('/corporate/booking');
      }
    } else {
      setIsLoading(false);
      history.replace('/corporate/login-not-authorized');
    }

    setIsLoading(false);
  };

  return <UserCountrySelectionComponent isLoading={isLoading} countries={countryList} onClick={handleOnClick} />;
};

export default UserCountrySelectionContainer;
